import request from '@/utils/request'; // 更改业主

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/insert',
    method: 'post',
    data: data
  });
} // 查询用户信息

export function fetchCustomerList(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/getCustomer',
    method: 'post',
    data: data
  });
} // 更改历史纪录列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/list',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/info',
    method: 'post',
    data: data
  });
} // 获取房屋住户列表

export function findHousePerson(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/findHousePerson',
    method: 'post',
    data: data
  });
} // 添加房屋住户

export function insertHousePerson(data) {
  return request({
    url: '/pmsservice/api/roomCustomer/insertHousePerson',
    method: 'post',
    data: data
  });
}